import _ from 'lodash';
import onboardingApi from '../../api/OnbordingApi';
import consts from '../../constants/onboarding-state';
import CredentialsApi from '../../api/CredentialsApi';
import DDLogs from '../../DDLogs';

const state = {
  isLoading: false,
  pageName: null,
  error: null,
  pageParams: null,
  credentials: [],
  saveCredentialsError: false,
  nameAlreadyUsedError: false,
  loadingStartTime: null,
};

const getters = {
  invalidCredentials: state => state.error === 'invalidCredentials',
  sourceName: state => (state.pageParams ? state.pageParams.sourceName : null),
  onboardingCompleted: state => state.onboardingPage && state.onboardingPage === consts.ONBOARDING_PAGE.CASHFLOW,
};

const actions = {
  async fetchOnboardingState({ commit }) {
    const { onboardingState } = await onboardingApi.fetchOnboardingState();
    DDLogs.log('fetchOnboardingState', onboardingState);
    if (onboardingState) {
      commit('setPageName', onboardingState.onboardingPage);
      commit('setLoadingState', onboardingState.isLoading);
      commit('setError', onboardingState.error);
      commit('setPageParams', onboardingState.pageParams);
      commit('setLoadingStartTime', onboardingState.loadingStartTime);
      if (finishedOnboardingFlow(state.pageName)) {
        commit('setPageName', consts.ONBOARDING_PAGE.CASHFLOW_LOADER);
      }
    }
  },
  async handleBack({ commit, getters }, pageParams) {
    const { onboardingState } = await onboardingApi.back();
    commit('setPageName', onboardingState.onboardingPage);
    commit('setLoadingState', onboardingState.isLoading);
    commit('setError', onboardingState.error);
    const pageParamsToSet = pageParams || onboardingState.pageParams;
    commit('setPageParams', pageParamsToSet);
  },
  deletePageParams({ commit, dispatch }, pageParams) {
    if (pageParams) {
      commit('setPageParams', pageParams);
    } else {
      commit('setPageParams', null);
    }
    dispatch('handleBack', pageParams);
  },
  async deletePendingCreds({ commit }, pageParams) {
    commit('setLoadingState', true);
    const { onboardingState } = await CredentialsApi.deletePendingCredentials();
    commit('setPageName', onboardingState.onboardingPage);
    commit('setLoadingState', onboardingState.isLoading);
    commit('setError', onboardingState.error);
    commit('setPageParams', pageParams);
    commit('setLoadingStartTime', onboardingState.loadingStartTime);
    commit('setLoadingState', false);
  },
  async getNextPage({ commit }) {
    const { onboardingState } = await onboardingApi.nextOnboardingPage();
    commit('setPageName', onboardingState.onboardingPage);
    commit('setLoadingState', onboardingState.isLoading);
    commit('setError', onboardingState.error);
    commit('setPageParams', onboardingState.pageParams);
    commit('setLoadingStartTime', onboardingState.loadingStartTime);
  },
  async nextPage({ state, dispatch, commit }) {
    await dispatch('getNextPage');
    if (finishedOnboardingFlow(state.pageName)) {
      commit('setPageName', consts.ONBOARDING_PAGE.CASHFLOW_LOADER);
    }
  },
  async savePageName({ commit, dispatch }, pageName) {
    commit('setPageName', pageName);
    await onboardingApi.updateOnboardingPage(pageName);
  },
  async saveCredentials({ commit, dispatch, state }, { sourceName, credentials, name, sourceType }) {
    commit('setSaveCredentialsError', false);
    if (!state.error) {
      await dispatch('validateName', { sourceName, name });
      if (state.nameAlreadyUsedError) {
        return;
      }
    }
    try {
      commit('setLoadingState', true);
      await CredentialsApi.saveCredentials({ sourceName, credentials, name, sourceType });
    } catch (e) {
      commit('setSaveCredentialsError', true);
      commit('setLoadingState', false);
    }
  },
  async savePendingCredentials({ commit, dispatch, state }, { sourceName, credentials, name }) {
    commit('setSaveCredentialsError', false);
    try {
      commit('setLoadingState', true);
      return await CredentialsApi.savePendingCredentials({ sourceName, credentials, name });
    } catch (e) {
      commit('setSaveCredentialsError', true);
      commit('setLoadingState', false);
      return null;
    }
  },
  async validateName({ commit, dispatch, state }, { sourceName, name }) {
    await dispatch('fetchCredentials');
    const existingCreds = _.find(state.credentials, { sourceName, name });
    if (existingCreds && existingCreds.status !== 'pending') {
      commit('setNameAlreadyInUseError', true);
    }
  },
  async fetchCredentials({ commit }) {
    const credentials = await CredentialsApi.fetchCredentials();
    commit('setCredentials', credentials);
  },
};

function finishedOnboardingFlow(pageName) {
  return pageName === consts.ONBOARDING_PAGE.CASHFLOW;
}

const mutations = {
  setPageName(state, pageName) {
    state.pageName = pageName;
  },
  setPageParams(state, pageParams) {
    state.pageParams = pageParams;
  },
  setLoadingState(state, isLoading) {
    DDLogs.log(`setLoadingState to ${isLoading}`);
    state.isLoading = isLoading;
  },
  setLoadingStartTime(state, loadingStartTime) {
    state.loadingStartTime = loadingStartTime;
  },
  setError(state, error) {
    state.error = error;
  },
  setNameAlreadyInUseError(state, nameAlreadyUsedError) {
    state.nameAlreadyUsedError = nameAlreadyUsedError;
  },
  setSaveCredentialsError(state, saveCredentialsError) {
    state.saveCredentialsError = saveCredentialsError;
  },
  setCredentials(state, credentials) {
    state.credentials = credentials;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
